import React from 'react';
import { Box, Button, Text } from 'grommet';
import { Play, Pause, ChapterNext, ChapterPrevious } from 'grommet-icons';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentSession, getTotalSessionsCount, getIsPaused } from 'src/reducers/workSessions/workSessionsSelectors';
import { toggleIsPaused, rewindWorkBreak, skipWorkBreak } from 'src/reducers/workSessions/workSessionsReducer';

function Controls(): JSX.Element {
  const dispatch = useDispatch();
  const currentSession = useSelector(getCurrentSession);
  const totalSessionsCount = useSelector(getTotalSessionsCount);
  const isPaused = useSelector(getIsPaused);
  const PlayPauseIcon = isPaused ? Play : Pause;

  const togglePause = () => dispatch(toggleIsPaused());
  const rewind = () => dispatch(rewindWorkBreak());
  const skip = () => dispatch(skipWorkBreak());

  return (
    <Box direction='column' align='center'>
      <Text margin='small'>{`Session ${currentSession} of ${totalSessionsCount}`}</Text>
      <Box direction='row' gap='small'>
        <Button icon={<ChapterPrevious />} onClick={rewind} plain={false} />
        <Button icon={<PlayPauseIcon />} onClick={togglePause} primary />
        <Button icon={<ChapterNext />} onClick={skip} plain={false} />
      </Box>
    </Box>
  );
}

export default Controls;
